// Vendors
import { convertPxsToRems } from '@openbank/cf-ui-framework';
import { COBRANDED_LIGHT_REGULAR_STYLES } from '@openbank/ziniaweb-ui-components';
import styled from 'styled-components';

const EntrypointOrchestratorUncategorizedStyled = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_250};
  max-width: ${convertPxsToRems({ pixels: 682, base: 16 })};
  margin: 0 auto;
  width: 100%;

  ${COBRANDED_LIGHT_REGULAR_STYLES.MEDIA_QUERIES.onlyMobile} {
    margin: 0;
    max-width: 100%;
    padding: 0 ${({ theme }) => theme.spacing_250};
  }
`;
EntrypointOrchestratorUncategorizedStyled.displayName = 'EntrypointOrchestratorUncategorizedStyled';

export { EntrypointOrchestratorUncategorizedStyled };
